import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Download } from "lucide-react";
import { api, errMsg, inr, sign, download } from "@/lib/api";
import { Side } from "@/components/Bits";

export default function History() {
  const [runs, setRuns] = useState(null);
  const load = () => api.get("/runs").then((r) => setRuns(r.data));
  useEffect(() => { load(); }, []);
  const del = async (id) => { if (!window.confirm("Delete this run from history?")) return; try { await api.delete(`/runs/${id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-3" data-testid="history-page">
      <div className="flex flex-wrap items-center gap-2">
        <h1 className="text-xl font-semibold text-slate-100 mr-auto">History</h1>
        {[["live", "Live trades"], ["backtest", "Backtest trades"], ["all", "All trades"]].map(([sc, l]) => (
          <button key={sc} onClick={() => download(`/export/trades.csv?scope=${sc}`, `lvrc_trades_${sc}.csv`).catch((e) => toast.error(errMsg(e)))}
            data-testid={`export-csv-${sc}`} className="h-8 px-3 rounded-md border border-[#334155] text-xs text-slate-300 hover:text-white hover:border-cyan-500/50 flex items-center gap-1.5">
            <Download size={12} />{l} CSV
          </button>
        ))}
      </div>
      {runs && !runs.length && <div className="panel p-6 label-xs" data-testid="history-empty">No runs saved yet</div>}
      <div className="panel divide-y divide-[#1E293B]">
        {runs?.map((r) => {
          const net = r.type === "backtest" ? r.summary?.net : r.net;
          return (
            <div key={r.id} className="flex items-center gap-3 px-3 py-2.5 hover:bg-[#172033]" data-testid={`history-row-${r.id}`}>
              <Link to={`/history/${r.id}`} className="flex-1 min-w-0 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={`history-open-${r.id}`}>
                <span className={`uppercase px-1.5 py-0.5 rounded border ${r.type === "backtest" ? "border-violet-500/40 text-violet-300" : "border-cyan-500/40 text-cyan-300"}`}>{r.type === "backtest" ? "backtest" : r.mode}</span>
                <span className="num text-slate-200">{r.type === "backtest" ? `${r.date_from} → ${r.date_to}` : r.date}</span>
                <span className="text-slate-500">{r.source === "kite" ? "Kite" : r.source === "kite_replay" ? "Kite replay" : "SAMPLE"}</span>
                {r.auto_started && <span className="text-amber-300/80">auto</span>}
                {r.type === "live" && <><Side side={r.bias} /><span className="text-slate-400">{r.sector}</span><span className="text-slate-500">{r.status}</span></>}
                {r.type === "backtest" && <span className="text-slate-400">{r.summary?.trades} trades · {r.summary?.win_rate}% win</span>}
              </Link>
              <span className={`num text-sm ${sign(net)}`}>{inr(net)}</span>
              <button onClick={() => del(r.id)} className="p-1.5 text-slate-500 hover:text-red-400" data-testid={`history-delete-${r.id}`}><Trash2 size={14} /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
